import { useFormikContext, FieldArray, useField } from "formik"

//PrimeReact
import { InputText } from "primereact/inputtext"

//styles
import styles from "../../../styles/Form-Inputs.module.css"
import docsTemplateStyles from "../../../styles/documentSigning/DocSign.templates.module.css"
import { useState } from "react"

function GetRoleInput({ fieldName, index, allowRemove, onRemoveCallback }) {
  const [field] = useField(fieldName)
  return (
    <div className={docsTemplateStyles.fileUploadGroup}>
      <InputText
        value={field.value}
        name={field.name}
        onChange={field.onChange}
        onBlur={field.onBlur}
        placeholder={"Please specify a role name"}
        className={`${docsTemplateStyles.addedOptions}`}
      />
      {allowRemove ? (
        <button
          type="button"
          className={`btn template-t-tip ${docsTemplateStyles.removeOption}`}
          data-pr-tooltip={"Remove document"}
          data-pr-position="bottom"
          onClick={() => {
            onRemoveCallback()
          }}
        >
          <span className={`material-icons`}>{"delete"}</span>
        </button>
      ) : null}
    </div>
  )
}

export default function NewTemplateSignerRoles({
  fieldName,
  label,
  placeholder,
  required,
  helpText,
  disabled,
}) {
  const { values, errors } = useFormikContext()
  const [refresh, setRefresh] = useState(false)

  return (
    <div className={styles.field}>
      <label>
        {label} {required ? <span style={{ color: "red" }}> * </span> : null}
      </label>
      <div className="col-12 md:col-10">
        {helpText ? (
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
        <FieldArray
          name={fieldName}
          render={(arrayHelpers) => (
            <div>
              {values[fieldName].map((friend, index) => (
                <div key={index}>
                  <GetRoleInput
                    fieldName={`${fieldName}.${index}`}
                    index={index}
                    allowRemove={values[fieldName].length > 1}
                    onRemoveCallback={() => {
                      arrayHelpers.remove(index)
                      setRefresh(!refresh)
                    }}
                  />
                </div>
              ))}
              {typeof errors[fieldName] === "string" ? (
                <label id={`${fieldName}-error`} className={styles.errFieldMsg}>
                  {errors[fieldName]}
                </label>
              ) : null}
              <div className={docsTemplateStyles.addOptionButton}>
                <button
                  className={`btn`}
                  onClick={() => {
                    arrayHelpers.push("")
                  }}
                  disabled={values[fieldName].length >= 5}
                >
                  Add Signer Role
                </button>
              </div>
            </div>
          )}
        />
      </div>
    </div>
  )
}
